<template>
  <stat :title="$t('dashboard.sessions.title')" :loading="loading">
    <sessions-chart
      v-if="totalResults !== 0"
      :dataKey="dataKey"
      :params="params"
      :height="200"
      style="width: 100%"></sessions-chart>
    <small v-else>{{ $t('dashboard.sessions.notActivated') }}</small>
  </stat>
</template>

<script>
  import { SessionsChart } from '@/components/charts'
  import stats from '@/mixins/stats'
  export default {
    components: {
      SessionsChart
    },
    mixins: [stats],
    props: {
      dataKey: {
        type: String,
        default: 'sessions'
      }
    }
  }
</script>

<style scoped>
  small { font-size: .5em; }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/Sessions.vue